import {array} from 'yup';

import i18n from '../../../i18n/i18n';

const FIELD_REQUIRED_MESSAGE_KEY = 'page.create.validation.fieldIsRequired';

export function buildChipsOneOfValidation(
  allowedValues: string[],
  messageKey: string,
  getValueLabel: (value: string) => string
) {
  return array()
    .required(i18n.t(FIELD_REQUIRED_MESSAGE_KEY))
    .min(1, i18n.t(FIELD_REQUIRED_MESSAGE_KEY))
    .test({
      name: 'oneOf',
      test(values, context) {
        const list = values ?? [];
        const firstInvalid = list.find((v) => !allowedValues.includes(v ?? ''));
        if (firstInvalid !== undefined) {
          const valueLabel = getValueLabel(firstInvalid ?? '');
          return context.createError({
            message: i18n.t(messageKey, {value: valueLabel}),
          });
        }
        return true;
      },
    });
}
